import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

import Topbar from '../components/Topbar';
import Sidebar from "../components/Sidebar";
import UserDetailsCard from "../../../admin/components/report/UserDetailsCard";

const UserDetails = ({ token, client }) => {

    const history = useHistory();

    const [toggled, setToggled] = useState(false);

    useEffect(() => {
        if (!client || !client.user_detail) {
            history.push('/client')
        }
    }, [])

    const handleToggle = () => {
        setToggled(!toggled);
    }

    return (
        <div className="admin-page-container">
            <Sidebar toggled={toggled} setToggled={handleToggle} />
            <div className="admin-page">
                <Topbar handleToggle={handleToggle} />
                <div className="admin-content">
                    <UserDetailsCard 
                        role="client"
                        token={token}
                        stampSetting={client.stamp}
                        tokenSetting={client.token}
                        pointSetting={client.loyalty_point}
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        client: state.client.client,
        token: state.client.token
    };
};
export default connect(mapStateToProps, null)(UserDetails);
